import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	exportIssuesFlagDownloadErrorTitle: {
		id: 'issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-download-flag.export-issues-flag-download-error-title',
		defaultMessage: "We couldn't download your issues",
		description: 'Title of export issues flag when there is an error while downloading the file',
	},
});

export default messages;
